import formatAssignmentOption from '$utils/formatAssignmentOption';

const getAssignmentOptions = ({ mappings, assignments }) =>
  mappings.map(({ id: mappedId }) => {
    const assignment = assignments.find(
      ({ id: assignmentId }) => mappedId === assignmentId
    );

    if (!assignment) {
      return {
        name: 'Unknown assignment',
        value: mappedId,
        isDisabled: false,
      };
    }

    return formatAssignmentOption(assignment);
  });

export default getAssignmentOptions;
